(function () {
    'use strict';

    angular
        .module('app')
        .controller('CitySearchController', CitySearchController);

    CitySearchController.$inject = ['$scope', '$state', 'dialog', '$http', 'authenticator'];

    function CitySearchController($scope, $state, dialog, $http, authenticator) {
        var vm = this;

        vm.search_results = [];
        vm.show_results = false;

        vm.$onInit = function () {
            authenticator.checkLoginStatus()
                .then(function (isLoggedIn) {
                    vm.logged_in = isLoggedIn;
                    if(vm.logged_in) {
                        setUserPosition();
                    } else {
                        navigator.geolocation.getCurrentPosition(positionCallback);
                    }
                });
        }

        function setUserPosition() {
            $http.get('api/private/users/').then(function (response) {
                $http.get('api/city_search/' + response.data.user_postcode).then(function (response) {
                    vm.search_results = response.data;
                    if(vm.search_results.length>0) {
                        vm.choose(vm.search_results[0]);
                    }
                });
            });
        }

        function positionCallback(pos) {
            var coords = pos.coords;
            $http.get('api/city_position_search/' + coords.latitude + '/' + coords.longitude).then(function (response) {
                vm.choose(response.data);
            });
        }

        vm.searchClick = function() {
            if(vm.city_chosen) {
                vm.city_chosen = false;
                vm.search_text = "";
                vm.data = {};
            }
        }

        vm.choose = function(city) {
            vm.data = city;
            vm.city_chosen = true;
            vm.show_results = false;
            vm.search_text = vm.data.area + ', ' + vm.data.country;
        }

        vm.citySearch = function() {
            $http.get('api/city_search/' + vm.search_text).then(function (response) {
                vm.search_results = response.data;
                vm.show_results = true;
            });
        }

        vm.cityPositionSearch = function() {
            $http.get('api/city_position_search/' + vm.search_text).then(function (response) {
                vm.search_results = response.data;
                vm.show_results = true;
            });
        }

        $scope.$watch('vm.search_text', function () {
            if(!vm.city_chosen && vm.search_text && vm.search_text.length > 1) {
                vm.citySearch();
            }
        });

    }
})();

